// Lightweight analytics adapter. Pushes events to `window.dataLayer` (the
// industry-standard pattern read by GTM, GA4, Plausible's GTM bridge, etc.),
// gated on the analytics-consent flag set by the cookie banner.
//
// If no analytics tag is loaded, `window.dataLayer` is just an array — events
// queue silently and are picked up the moment a tag is added. No-op-safe.

const CONSENT_COOKIE = "tt_consent";

function consentAllowsAnalytics() {
  if (typeof document === "undefined") return false;
  const raw = document.cookie
    .split("; ")
    .find(c => c.startsWith(`${CONSENT_COOKIE}=`));
  if (!raw) return false;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw.split("=")[1] || ""));
    return parsed && parsed.analytics === true;
  } catch {
    return false;
  }
}

export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  if (!consentAllowsAnalytics()) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}
